import { Injectable, Type } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { map, Observable } from 'rxjs';
import { TextInputDialogComponent } from './text-input-dialog/text-input-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private _dialog: MatDialog, private _confirm: FuseConfirmationService) {}

  showConfirmDialog(title: string, message: string): Observable<boolean> {
    return this._confirm
      .open({
        title,
        message,
        actions: {
          confirm: {
            label: 'Yes',
          },
          cancel: {
            label: 'Cancel',
          },
        },
      })
      .afterClosed()
      .pipe(map((result: string) => result === 'confirmed'));
  }

  openDialog<T, K>(component: Type<any>, config?: MatDialogConfig<T>): Observable<K> {
    return this._dialog
      .open(component, {
        minWidth: '420px',
        ...config,
      })
      .afterClosed();
  }

  openTextFieldDialog(title: string, placeholder: string, value = ''): Observable<string> {
    return this.openDialog(TextInputDialogComponent, {
      data: {
        title,
        placeholder,
        value,
      },
    });
  }
}
